const LockedFormHelperTextProps = {
  /**
   * When showing a locked field for an integration, we want to
   * main the gap in the grid layout. The margin classes will allow
   * for keeping that gap. Without it, the gap between fields will
   * look off as the helper text itself adds to that gap.
   */
  className: '[&:not(:empty)]:mt-[-4px] [&:not(:empty)]:mb-[-16px]',
};

export default LockedFormHelperTextProps;
